import { makeStyles } from "@mui/styles";
import { IMG_TELKOM } from "@config/images";
import color from "@definitions/mui/color";
import { fontFamSecondary } from "@definitions/mui/custom";

interface IProps {
  isMobile?: boolean;
  isVisible?: boolean;
  isDesktop?: boolean;
}

const useStyles = ({ isMobile, isDesktop }: IProps) => {
  return makeStyles(() => ({
    base: {
      backgroundColor: "#FFFFFF !important",
      paddingTop: isMobile || isDesktop ? 0 : 70,
      maxWidth: "100%",
      minHeight: "100vh",
      fontSize: 16,
      position: "relative",
      color: "#2E434D",
    },
    category: {
      height: isMobile ? 26 : 32,
      backgroundColor: "#293780",
      color: "#FFF",
      fontSize: "14px",
    },
    date: {
      marginLeft: "8px",
      color: "#808C92",
      "&:before": {
        content: '""',
        display: "inline-block",
        borderRadius: "50%",
        width: "6px",
        height: "6px",
        backgroundColor: "#2E434D",
        marginRight: "8px",
        marginBottom: "2px",
      },
    },
    img: {
      width: "100%",
      minWidth: "100%",
      height: "300px",
      objectFit: "cover",
      marginBottom: "24px",
    },
    footer: {
      width: "100%",
      backgroundColor: "#E2E4E5",
      height: "40px",
      display: "flex",
      textAlign: "center",
      alignItems: "center",
    },
    interest: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "40px",
      padding: "16px",
      borderRadius: "8px",
      color: "#FFF",
      lineHeight: "14px",
      background: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)),
      url("${IMG_TELKOM}") center/cover no-repeat`,
    },
    content: {
      "& p, span": {
        fontFamily: fontFamSecondary + " !important",
        fontSize: "16px !important",
        marginTop: 0,
        marginBottom: 4,
      },
      "& a": {
        "&:hover": {
          textDecoration: "underline !important",
        },
        color: color.blue.mid + " !important",
      },
      "& ul": {
        paddingInlineStart: "24px !important",
      },
      "& li": {
        whiteSpace: "normal !important",
      },
      fontSize: 16,
      lineHeight: 1.4,
      color: color.general.main,
      minHeight: 500,
    },
    stickyHeader: {
      backgroundColor: color.white,
      position: "fixed",
      top: isDesktop ? 70 : 0,
      width: "100%",
      boxShadow: isDesktop ? "none" : "0px 6px 12px rgba(46, 67, 77, 0.1)",
      transition: "all 0.3s ease",
      zIndex: 1,

      "& .MuiInputBase-root": {
        width: "100%",
      },
    },
    tab: {
      borderBottom: isDesktop ? 0 : "1px solid #DEE3ED",
      "& .MuiTabs-root": {
        minHeight: 0,
        "& .MuiTabs-flexContainer": {
          "& button": {
            padding: isDesktop ? "0 12px 10px 12px" : "0 16px 10px 16px",
            minHeight: 0,
            ...(isDesktop && {
              minWidth: 0,
            }),
            "& span": {
              fontWeight: "400",
              color: color.inactive.secondary,
              lineHeight: "19px",
            },
            "&.Mui-selected": {
              "& span": {
                fontWeight: "600",
                color: color.primary.main,
              },
            },
          },
          "& + .MuiTabs-indicator": {
            backgroundColor: "#E08D99",
            borderRadius: 4,
          },
        },
      },
    },
    filter: {
      "& > button": {
        padding: 12,
        fontSize: 14,
        height: "32px",
        minWidth: 0,
        "& + button": {
          marginLeft: "8px",
        },
        "& svg": { width: 16, height: 16 },
      },
    },
    anchor: {
      position: "relative",
      scrollMarginTop: "24rem",
      "&:before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        paddingTop: 100,
      },
    },
  }))();
};

export default useStyles;


